// extracted by mini-css-extract-plugin
export default {"overlay":"overlay_overlay__4PN0p","rectangle":"overlay_rectangle__oSg7E","text":"overlay_text__OeAEh","img":"overlay_img__ByB+v","button":"overlay_button__4xwQu"};